/**
 * API Configuration.
 * Priority:
 * 1. Runtime value injected into globalThis.__API_BASE_URL
 * 2. Build-time value from NEXT_PUBLIC_API_BASE_URL
 *
 * No localhost fallback in non-local environments.
 */

function normalizeUrl(url: string): string {
  return url.replace(/\/+$/, "");
}

export function getBaseUrl(): string {
  const runtimeUrl =
    typeof globalThis !== "undefined"
      ? (globalThis as { __API_BASE_URL?: string }).__API_BASE_URL
      : undefined;

  const envUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

  const resolvedUrl = runtimeUrl || envUrl;

  if (!resolvedUrl) {
    throw new Error(
      "API base URL is missing. Set globalThis.__API_BASE_URL or NEXT_PUBLIC_API_BASE_URL."
    );
  }

  return normalizeUrl(resolvedUrl);
}

export const API_CONFIG = {
  get BASE_URL(): string {
    return getBaseUrl();
  },
  TIMEOUT: 50000,
} as const;
